import { PagedResults } from 'src/data/types/paging';
import { TrackedUser } from 'src/data/types/tracked-users/types';
import { createController, createControllerEndpoint } from 'src/utils/api';
import { getGlobalProject } from 'src/utils/globals';

const project = getGlobalProject() || { UniqueCode: '' };

export default createController('/api/v1/insights/' + project.UniqueCode, {
    getTrackedUsers: createControllerEndpoint<PagedResults<TrackedUser>>('GET', '/users'),
    getTrackedUserDetails: createControllerEndpoint<TrackedUser>('GET', '/user-detail/{username}'),
    startTrackedUsersActivityExport: createControllerEndpoint<void>('POST', '/users/activity/export'),
});
